import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableApprovalQuotaRetractionView.
 * @extends JetView
 */
export default class tableApprovalQuotaRetractionView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Getting partner ID from parameters
        const data = [
            // Sample data for the datatable
            {
                Id: '01',
                Title: 'Prueba 1',
                Description: 'Descripción de la petición numero 1',
                Department: '0',
                State: '0',
                UserCreated: '001',
                DateCreation: '2019-02-13 11:32:20',
            },
            {
                Id: '02',
                Title: 'Prueba 2',
                Description: 'Descripción de la petición numero 2',
                Department: '1',
                State: '1',
                UserCreated: '002',
                DateCreation: '2019-02-12 10:32:20',
            },
        ];
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // Datatable view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'ActionTittle', // Column ID
                                    header: '', // Column header
                                    width: 65, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip for the column
                                    template: function (obj) {
                                        // Template function for rendering actions
                                        if (obj.StateId !== 'P') {
                                            return ''; // No actions if state is not 'P'
                                        } else {
                                            if (devConfig.getPermAction('approvalQuotaRetraction', 'Approve')) {
                                                return "<span class='webix_icon wxi-close approve prm-approvalQuotaRetraction'></span><span class='webix_icon wxi-close torefuse prm-approvalQuotaRetraction'></span>"; // Action icons for approve and refuse
                                            } else {
                                                return ''; // No actions if permission is not granted
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'UserCreate', // Column ID
                                    header: _('Usuario Creó'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        // Number formatting
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                                {
                                    id: 'StateId', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Aprobada') },
                                        { id: 'R', value: _('Rechazada') },
                                        { id: 'P', value: _('Pendiente') },
                                    ],
                                    width: 110, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                torefuse: function (euv, id) {
                                    // Handler for refuse action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar la Retracción de Saldo?'),
                                        ok: _('Rechazar Retracción de Saldo'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // AJAX request to the server
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Agent/ApprovalQuotaRetraction',
                                                        '{"Id":"' +
                                                            item.Id +
                                                            '", "State":"R", "Partner":"' +
                                                            id_partner +
                                                            '"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (json.HasError) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error', // Error alert type
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte',
                                                                        ),
                                                                    });
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Estado de Retracción actualizado', // Success message
                                                                        ),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning', // Warning alert type
                                                                    });
                                                                    item.StateId = 'R'; // Update item state
                                                                    $$('datatable').refresh(); // Refresh datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approve: function (euv, id) {
                                    // Handler for approve action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar el Retracción de Saldo?'),
                                        ok: _('Aprobar Retracción de Saldo'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // AJAX request to the server
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Agent/ApprovalQuotaRetraction',
                                                        '{"Id":"' + item.Id + '", "State":"A"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                console.log(
                                                                    text, // Log response
                                                                );
                                                                var json = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (json.HasError) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error', // Error alert type
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte',
                                                                        ),
                                                                    });
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Estado de Retracción actualizado', // Success message
                                                                        ),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning', // Warning alert type
                                                                    });
                                                                    item.StateId = 'A'; // Update item state
                                                                    $$('datatable').refresh(); // Refresh datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            on: {
                                // Event handlers for datatable
                                onItemDblClick: function () {
                                    // Double click event
                                    $$('editwin').show(); // Show edit window
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead option
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Getting partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'null/Report/GetQuotaRetraction?Partner=' + id_partner + '&'; // API URL for fetching quota retraction data
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string for requests
        this.on(this.app, 'requests:filter', (filterData) => {
            // Event listener for filter requests
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date; // Handle single date filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to filter string
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event for after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        var ttt = webix.ui({
            // Create edit window UI
            view: 'window',
            move: true,
            id: 'editwin', // ID for the edit window
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar'), align: 'center' }, // Label for the toolbar
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the edit window
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form inside the window
                id: 'editform', // ID for the edit form
                elements: [
                    {
                        view: 'text',
                        label: _('UserName'), // Label for username field
                        name: 'UserName',
                        readonly: true, // Read-only field
                    },
                    {
                        view: 'imageLabel', // Custom image label view
                        name: _('Imagen'), // Name for the image label
                        width: 500, // Width of the image label
                        height: 500, // Height of the image label
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Listo'), // Button text
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the edit window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        $$('editform').bind($$('datatable')); // Bind the edit form to the datatable
    }
}

// Custom UI component for displaying an image
webix.protoUI(
    {
        name: 'imageLabel', // Name of the custom component
        setValue: function (value) {
            // Function to set the image source
            this.setHTML(
                "<img style='width:100%;height: 100%;' src='" + value + "'></img>", // Set HTML for the image
            );
        },
    },
    webix.ui.label, // Base component
);

// FILE DOCUMENTED
